
import { DocumentMaster } from "./DocumentMaster.model";
import { User } from "./User.model";

export class UserDocument{
    public userDocumentId:number;
    public fileType:string;
    public entityType:string;
    public user:User;
    public userId:number;
    public documentMaster:DocumentMaster;
    public documentMasterId:number;
    public isDelete:string;
    public createdDate:Date;
    public modifiedDate:Date;
}